/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NavbarPosition {
  Default = 'Default',
  None = 'None',
  Bottom = 'Bottom',
  Top = 'Top',
}
